<template>
  <div style="display: flex">
    <div v-if="imgUrl" style="flex-shrink: 0">
      <img :src="imgUrl" alt="Graphical View" />
      <p>
        <span class="">
          <b>{{ value.valor.toFixed(2) }}</b> às {{ formatedDate }}
          <md-tooltip md-direction="right">{{ fullFormatedDate }}</md-tooltip>
        </span>
      </p>
    </div>
    <div v-else style="text-align: left">
      <md-progress-spinner
        :md-diameter="50"
        :md-stroke="5"
        md-mode="indeterminate"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import {
  registerChannelListener,
  removeChannelListener,
} from '@/utils/web-socket'

import http from '../../../utils/http'

export default {
  name: 'ViewShowGraphical',
  components: {},
  props: {
    componente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      graphicalView: null,
      value: null,
      channel: null,
      refToListener: null,
      refToListenerVirtual: null,
    }
  },
  computed: {
    imgUrl() {
      if (this.graphicalView === null || this.value === null) return null

      const min = this.componente.value.min
      const max = this.componente.value.max

      const filesCount = this.graphicalView.files.length
      const currentValue = this.value.valor

      let index = Math.floor(((currentValue - min) / (max - min)) * filesCount)

      if (index < 0) index = 0
      else if (index >= filesCount) index = filesCount - 1

      return this.graphicalView.files.reduce((acc, e) => [e, ...acc], [])[index]
        .url
    },
    formatedDate() {
      if (this.value === null) return null

      const date = new Date(this.value.horarioColeta)
      return moment(date).format('HH:mm')
    },
    fullFormatedDate() {
      if (this.value === null) return null

      const date = new Date(this.value.horarioColeta)
      return date.toLocaleString()
    },
  },
  async beforeMount() {
    const task1 = http
      .get(`graphical-view/${this.componente.value.graphicalViewId}`)
      .then((e) => {
        this.graphicalView = e
      })

    let task2

    if (this.componente.value.sensorId !== null) {
      http
        .get(`sensor/${this.componente.value.sensorId}/ultima-coleta`)
        .then((e) => {
          this.value = e
        })
    }

    if (this.componente.value.sensorVirtualId !== null) {
      await http
        .get(`sensor/virtual/${this.componente.value.sensorVirtualId}/evaluate`)
        .then((e) => {
          this.value = {
            horarioColeta: new Date().toISOString(),
            valor: e.result,
          }
        })
    }

    await Promise.all([task1, task2])

    if (this.componente.value.sensorId !== null) {
      await this.beginListenSensores()
    }

    if (this.componente.value.sensorVirtualId !== null) {
      await this.beginListenSensoresVirtuais()
    }
  },
  beforeDestroy() {
    if (this.refToListener !== null)
      removeChannelListener(
        'view_sensor_id:' + this.componente.value.sensorId,
        'sensor:update_value',
        this.refToListener
      )

    if (this.refToListenerVirtual !== null)
      removeChannelListener(
        'sensor_virtual_id:' + this.componente.value.sensorVirtualId,
        'update_value',
        this.refToListenerVirtual
      )
  },
  methods: {
    async beginListenSensores() {
      this.refToListener = await registerChannelListener(
        'view_sensor_id:' + this.componente.value.sensorId,
        'sensor:update_value',
        (payload) => {
          this.value = {
            horarioColeta: payload.horarioColeta,
            valor: payload.valor,
          }
        }
      )
    },
    async beginListenSensoresVirtuais() {
      this.refToListenerVirtual = await registerChannelListener(
        'sensor_virtual_id:' + this.componente.value.sensorVirtualId,
        'update_value',
        (payload) => {
          this.sensorVirtualValue = {
            horarioColeta: payload.horario,
            valor: payload.result,
          }
        }
      )
    },
  },
}
</script>

<style scoped></style>
